


import { ActivityIndicator, Dimensions, Modal, PixelRatio, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import MoneyIcon from '../../icons/MoneyIcon'
import Colours from '../../utils/Colours'
import VisaCardIcon from '../../icons/VisaCardIcon'
import TransferFromTable from './TransferFromTable'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import PurchaseFromTable from './PurchaseFromTable'
import useAuth from '../../hooks/useAuth'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import CalenderSignUpScreenModal from '../signInScreen/CalenderSignUpScreenModal'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const TableTrendDateSettings = ({ setSelectedDateData, hideModal, tableDataToUse }) => {
    const [isButtonClicked, setIsButtonClicked] = useState(false)
    const [showErrorAlert, setShowErrorAlert] = useState(false)
    const [showPickATrendDate, setShowPickATrendDate] = useState(false)
    const [showDateModal2, setShowDateModal2] = useState(false)
    const [selectedDate, setSelectedDate] = useState()
    const [selectedTrendDate, setSelectedTrendDate] = useState({})
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    // const [showTransferFromTable, setShowTransferFromTable] = useState(false)

    const [activePattern, setActivePattern] = useState('')

    const { activitySettings } = useAuth()

    const axiosPrivate = useAxiosPrivate();



    useEffect(() => {
        if (Object.keys(selectedTrendDate).length === 0) {
            //console.log('nill')
        } else {
            //console.log('Selected Trending Date', selectedTrendDate.selectedDate.toDateString())

        }
    }, [selectedTrendDate])

    useEffect(() => {
        if (activePattern === 'pickDate') {
            setShowDateModal2(true)
        }
    }, [activePattern])

    useEffect(() => {
        //console.log('tableDataToUse', tableDataToUse)
    }, [])


    const saveDateToDB = async (dateValue) => {
        try {
            // send to backend
            setIsLoading(true)
            const response = await axiosPrivate.post('/doingsTrendDate/doingsTrendDate', {
                selectedTrendsDate: dateValue,
                tableID: tableDataToUse?._id
            });

            //console.log('Saved date:', response.data);
        } catch (err) {
            //console.error('Error saving date:');
        } finally {
            setIsLoading(false)
        }
    }

    const handleSpendPattern = (pattern) => {
        setActivePattern(pattern)
    }

    // const handleShowTrendDateNotice = () => {
    //     setShowPickATrendDate(true)
    // }

    const saveSetTrendDate = () => {

        if (selectedDate === undefined) {
            setErrorMessage('Please enter a valid date')
            setShowErrorAlert(true)
        } else {
            const trendDateObj = { selectedDate }
            //console.log('trendDateObj:', trendDateObj)
            setSelectedTrendDate(trendDateObj)
            setShowDateModal2(false)
        }
    }

    const handleChoose = async () => {
        //setIsButtonClicked(true)
        //console.log('activePattern', activePattern)
        if (activePattern === 'instant') {
            //console.log('pattern', activePattern)
            setSelectedDateData('instant')
            await saveDateToDB('instant');
            hideModal(true)

        } else if (activePattern === '24hrs') {
            //console.log('pattern', activePattern)
            setSelectedDateData('24hrs')
            await saveDateToDB('24hrs');
            hideModal(true)

        } else if (activePattern === 'pickDate') {
            //console.log('pattern', activePattern)
            if (Object.keys(selectedTrendDate).length === 0) {
                setErrorMessage('Please enter a valid date')
                setShowErrorAlert(true)
            } else {
                setSelectedDateData(selectedTrendDate.selectedDate)
                await saveDateToDB(selectedTrendDate.selectedDate);
                hideModal(true)
            }


        } else {
            //console.log('Please select an active pattern')
        }
        //   hideScreen()
    }

    return (
        <View>
            <View style={styles.paymentMethodStyle}>
                <Text style={styles.useCaptionTxt}>Choose when this table should be published on the Doings Trend - You can only do this once</Text>
                {/* <View style={styles.dataContainer2}>
                    <View style={styles.dataSubContainer}>
                        <MoneyIcon color={Colours.PRIMARY_LIGHT} height={dynamicSize(30)} width={dynamicSize(30)} />
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={styles.moneyOnTableTxt}>Money on the table: </Text>
                                <Text style={styles.moneyAmtTxt}>{useContributionAmount} </Text>
                            </View>
                        </View>
                    </View>
                </View> */}

            </View>

            <View style={styles.paymentMethodStyle}>

                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activePattern === 'instant' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSpendPattern('instant')}
                >
                    <View style={styles.dataSubContainer}>
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={{ color: activePattern === 'instant' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>Instant </Text>

                            </View>
                        </View>
                    </View>
                </TouchableOpacity>

                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activePattern === '24hrs' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSpendPattern('24hrs')}
                >
                    <View style={styles.dataSubContainer}>
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={{ color: activePattern === '24hrs' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>24hrs after reservations </Text>

                            </View>
                        </View>
                    </View>
                </TouchableOpacity>

                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activePattern === 'pickDate' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSpendPattern('pickDate')}
                >
                    {Object.keys(selectedTrendDate).length === 0 ? (
                        <View style={styles.dataSubContainer}>
                            <View style={styles.captionAndDescribtion}>
                                <View style={styles.flatArrowContainer}>
                                    <Text style={{ color: activePattern === 'pickDate' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>Pick a Date</Text>

                                </View>
                            </View>
                        </View>
                    ) : (
                        <View style={styles.dataSubContainer}>
                            <View style={styles.captionAndDescribtion}>
                                <View style={styles.flatArrowContainer}>
                                    <Text style={{ color: activePattern === 'pickDate' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>Pick a Date{`: ${selectedTrendDate.selectedDate.toDateString()}`} </Text>

                                </View>
                            </View>
                        </View>
                    )}
                </TouchableOpacity>

                <TouchableOpacity style={[styles.buttonGray,
                { backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY }]}
                    onPress={() => handleChoose()}>

                    {isLoading ? (
                        <ActivityIndicator color={Colours.PRIMARY} size={'small'} />
                    ) : (
                        <Text style={styles.proceedTxt}>Proceed</Text>
                    )}
                </TouchableOpacity>

            </View>




            <Modal
                animationType='slide'
                visible={showDateModal2}
                onRequestClose={() => setShowDateModal2(false)}
            >
                <CalenderSignUpScreenModal
                    hidePullModal={() => setShowDateModal2(false)}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    saveSetBirthDate={saveSetTrendDate}
                    mode='future'
                />
            </Modal>




            <Modal
                visible={showErrorAlert}
                animationType='fade'
                transparent={true}

            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => {

                        setShowErrorAlert(false)
                    }}
                />
            </Modal>

        </View>
    )
}


const styles = StyleSheet.create({
    paymentMethodStyle: {
        display: 'flex',
        justifyContent: 'center',
        margin: dynamicSpacing(15),
        marginBottom: dynamicSpacing(4),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
        shadowColor: '#E8E8E8'
    },
    useCaptionTxt: {
        marginBottom: dynamicSpacing(10),
        color: Colours.DARKGRAY,
        fontSize: dynamicFontSize(15),
        fontFamily: 'Sen-Bold'
    },
    moneyOnTableTxt: {
        color: Colours.DARKGRAY,
        fontSize: dynamicFontSize(14),
        fontFamily: 'Sen-Regular'
    },
    moneyAmtTxt: {
        color: Colours.PRIMARY,
        fontSize: dynamicFontSize(15),
        fontFamily: 'Sen-Bold'
    },
    proceedTxt: {
        color: Colours.DARKGRAY,
        fontSize: dynamicFontSize(17),
        fontFamily: 'Sen-Bold'
    },
    dataContainer2: {
        display: 'flex',
        borderWidth: 1,
        borderColor: Colours.PRIMARY_LIGHTER,
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
        marginBottom: dynamicSpacing(10),
    },
    dataContainer: {
        display: 'flex',
        backgroundColor: 'white',
        margin: dynamicSpacing(10),
        marginTop: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
        marginBottom: dynamicSpacing(10),
    },
    dataSubContainer2: {
        display: 'flex',
        flexDirection: 'row',
        gap: dynamicSpacing(10),
        alignItems: 'center',
        marginBottom: dynamicSpacing(10)
    },
    dataSubContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: dynamicSpacing(10),
        alignItems: 'center'
    },
    flatArrowContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    captionAndDescribtion: {
        display: 'flex',
    },
    buttonGray: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: dynamicSpacing(10),
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.DARKGRAY,
    },
});

export default TableTrendDateSettings
